// extracted by mini-css-extract-plugin
export default {"paper":"ClientModifyView_paper__34GUu","input":"ClientModifyView_input___SEbK"};